/**************************************
 ** AtlasClientCapabilities
 *
 *  Contains information and logic on what to display in each environment
 ***************************************/
//IE8 - no radial load, render to div
//IE9, IE10 - radial load, render to div
//Safari, iOS - radial load, render to div
//Chrome, iOS - radial load, render to canvas
//*, Retina - radial load, render to div

//whether or not to allow any interactivity (e.g., IE6 = false)
//if the client support canvas
//if we should use rendering to canvas
//if the client supports addEventListener
//if the client has jquery events available
//if this is a retina screen
//the selected resolution
//the selected format
//the preference order of resolution and formats to load
define('atlas/AtlasClientCapabilities', [], function() {
    'use strict';

    var AtlasClientCapabilities = function() {
        this._capabilities = {
            allowInteractivity: true,
            canvasAvailable: false,
            renderToCanvas: false,
            eventListener: true,
            jqueryEvents: false,
            jqueryAvailable: false,
            isRetina: false,
            isRetinaCapable: false,
            windowDimensions: {
                width: 300,
                height: 300
            },
            resolution: '600',
            format: 'jpeg',
            //this will force 600x600 jpegs to be only option, this is okay until retina is being looked at
            //READ THE LINE ABOVE THIS ^^^
            imagePreferences: [{
                    resolution: '600',
                    format: 'jpeg'
            }],
            loadingSequence: null,
            latitudeSubset: null,
            loadConfigurator: true,
            loadingBailouts: [
                //options
                //index - array - ['*']=all, ['1', '2']=batch 1 and 2, undefined=not tested
                //interactivityChanged - bool - when interactivity has changed
                //retina - bool - on a retina device and loading retina images
                //configurator - bool - using the configurator
                //animationEnabled - bool - if interactivity is enabled
                //{ index: ['*'], interactivityChanged: false, retina: false, configurator: false, animationEnabled: false, averageImageTime: 10 }
                //{
                //    index: ['0'],
                //    interactivityChanged: true,
                //    averageImageTime: 1000
                //}
            ],
            forceRefreshDuration: 0
        };

        var iOS = (navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false);
        var chrome = ((navigator.userAgent.toLowerCase().indexOf('crios') > -1) || (navigator.userAgent.toLowerCase().indexOf('chrome') > -1));

        this._capabilities.allowInteractivity = !( !! window.ActiveXObject && !window.XMLHttpRequest); // if IE6

        //test for canvas
        var elem = document.createElement('canvas');
        this._capabilities.canvasAvailable = ( !! (elem.getContext && elem.getContext('2d')));

        this._capabilities.eventListener = (document.addEventListener !== undefined);
        if (!this._capabilities.eventListener) {
            //if event listeners are not available, then we will fall back to jquery
            this._capabilities.jqueryEvents = (typeof jQuery !== 'undefined');
        }
        this._capabilities.jqueryAvailable = (typeof jQuery !== 'undefined');
        this._capabilities.isRetina = (window.devicePixelRatio > 1);
        this._capabilities.isRetinaCapable = (window.devicePixelRatio > 1);
        if (this._capabilities.canvasAvailable) {
            //now that we have fixed retina issue, we are going to render to canvas where possible
            this._capabilities.renderToCanvas = true;
        }
        if ((iOS) && (chrome)) {
            //chrome iOS flickers, so use canvas for this
            this._capabilities.renderToCanvas = true;
        }

        this._capabilities.isChromeiOS = (iOS && chrome);

        this._refreshImagePreferences();
    };

    AtlasClientCapabilities.getInstance = function() {
        if (!AtlasClientCapabilities.instance) {
            AtlasClientCapabilities.instance = new AtlasClientCapabilities();
        }
        return AtlasClientCapabilities.instance;
    };

    AtlasClientCapabilities.getCapabilities = function() {
        return AtlasClientCapabilities.getInstance()._capabilities;
    };

    AtlasClientCapabilities.mergeCapabilities = function(newCapabilities) {
        function merge(newValue, currentValue) {
            //return (typeof newValue!=='undefined' ? newValue : currentValue);
            return (newValue || currentValue);
        }

        var capabilities=this.getCapabilities();

        //don't want to depend on jquery in the player (unless we compile parts of it in), and we don't want to
        //allow users to set all of these
        capabilities.allowInteractivity=merge(newCapabilities.allowInteractivity, capabilities.allowInteractivity);
        capabilities.renderToCanvas=merge(newCapabilities.renderToCanvas, capabilities.renderToCanvas);
        capabilities.isRetina=merge(newCapabilities.isRetina, capabilities.isRetina);
        capabilities.windowDimensions=merge(newCapabilities.windowDimensions, capabilities.windowDimensions);
        capabilities.resolution=merge(newCapabilities.resolution, capabilities.resolution);
        capabilities.format=merge(newCapabilities.format, capabilities.format);
        capabilities.loadingSequence=merge(newCapabilities.loadingSequence, capabilities.loadingSequence);
        capabilities.latitudeSubset=merge(newCapabilities.latitudeSubset, capabilities.latitudeSubset);
        capabilities.loadingBailouts=merge(newCapabilities.loadingBailouts, capabilities.loadingBailouts);

        return capabilities;
    };

    AtlasClientCapabilities.refreshImagePreferences = function() {
        var capabilities = AtlasClientCapabilities.getInstance();
        capabilities._refreshImagePreferences();
        return capabilities._capabilities;
    };

    AtlasClientCapabilities.prototype._refreshImagePreferences = function() {
        //if image preferences are defined already then don't do anything
        //BECAUSE DEFAULT IS SETTING IMAGE PREFERENCES THIS WILL ALWAYS HAPPEN
        if (this._capabilities.imagePreferences) {
            return;
        }

        if (this._capabilities.isRetina) {
            if (this._capabilities.windowDimensions.width === 600) {
                this._capabilities.imagePreferences = [{
                        resolution: '2k',
                        format: 'jpeg'
                    }, {
                        resolution: '600',
                        format: 'jpeg'
                    }, {
                        resolution: '300',
                        format: 'jpeg'
                    }
                ];
            } else if (this._capabilities.windowDimensions.width === 300) {
                this._capabilities.imagePreferences = [{
                        resolution: '600',
                        format: 'jpeg'
                    }, {
                        resolution: '300',
                        format: 'jpeg'
                    }, {
                        resolution: '2k',
                        format: 'jpeg'
                    }
                ];
            }
        } else {
            if (this._capabilities.windowDimensions.width === 600) {
                this._capabilities.imagePreferences = [{
                        resolution: '600',
                        format: 'jpeg'
                    }, {
                        resolution: '300',
                        format: 'jpeg'
                    }, {
                        resolution: '2k',
                        format: 'jpeg'
                    },
                ];
            } else if (this._capabilities.windowDimensions.width === 300) {
                this._capabilities.imagePreferences = [{
                        resolution: '300',
                        format: 'jpeg'
                    }, {
                        resolution: '600',
                        format: 'jpeg'
                    }, {
                        resolution: '2k',
                        format: 'jpeg'
                    }
                ];
            }
        }
    };

    return AtlasClientCapabilities;
});
